import React, {useCallback} from "react";

const UnitOfMeasure = ({selectedUnit, unit1, unit2, onChange}) => {

  const handleUnit1Change = useCallback(() => {
    onChange({unitOfMeasure: unit1});
  }, [selectedUnit, unit1]);

  const handleUnit2Change = useCallback(() => {
    onChange({unitOfMeasure: unit2});
  }, [selectedUnit, unit2]);

  return (
    <div className="pdp-main-block__subsection pdp-main-block__subsection--uom">
      <h6 className="pdp-main-block__qty-label">Unit</h6>

      <div className="qty-unit-switch">
        <input
          type="radio"
          name="qty-switch-1"
          id="urad1"
          checked={selectedUnit === unit1}
          onChange={handleUnit1Change}
        />
        <label
          htmlFor="urad1"
          className="qty-unit-switch__opt"
          role="button"
        >
          <span className="qty-unit-switch__opt-label">{unit1}</span>
        </label>

        {unit2 && (
          <React.Fragment>
            <input
              type="radio"
              name="qty-switch-2"
              id="urad2"
              checked={selectedUnit === unit2}
              onChange={handleUnit2Change}
            />
            <label
              htmlFor="urad2"
              className="qty-unit-switch__opt"
              role="button"
            >
              <span className="qty-unit-switch__opt-label">{unit2}</span>
            </label>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default UnitOfMeasure;
